import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NavigationTrackerService } from '../../shared/service/navigation-tracker.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { ReportsManagerService } from '../../shared/service/reports-manager-service';
import { environment } from '../../../environments/environment'
@Component({
    selector: 'full-layout',
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {

  public footer: any = []
    public config: PerfectScrollbarConfigInterface = {};
    public copyright: string = "© " + (new Date().getFullYear()) + " Voice Dialer developed by"
  arr: any=false;
    constructor(public router: Router,public routerChangeService:NavigationTrackerService, public datePipe:DatePipe) {
          let hostname : any  = environment.cental_url;
      
      this.routerChangeService.getDetails(hostname).subscribe(res=>{
        console.log("footer",res.data[0])
        this.footer = res.data[0].footer
      })
     }

    ngOnInit() {
      this.routerChangeService.getReportData().subscribe(rss=>{
        console.log("reports",rss)
        sessionStorage.setItem("user_reports",JSON.stringify(rss))
        this.arr=rss
      })
      this.startpopulate();
      setInterval(() => {
        this.startpopulate();
      }, 10*60*1000);
    }
    startpopulate(){
      this.routerChangeService.data_populatingreport().subscribe((res:any)=>{
        console.log('data populating start');
      })
    }
}